import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CardGridStyled } from '../../styled/cardGrid.styled';

const SectionList = props => {
  const { listAdditionalClasses, children, isNewDesign } = props;
  const listClasses = classNames('section-list', listAdditionalClasses);
  const refList = props.forwardedRef || null;

  return isNewDesign ? (
    <CardGridStyled className={listClasses} ref={refList}>
      {children}
    </CardGridStyled>
  ) : (
    <div className={listClasses} ref={refList}>
      {children}
    </div>
  );
};

SectionList.propTypes = {
  children: PropTypes.node,
  forwardedRef: PropTypes.object,
  listAdditionalClasses: PropTypes.string,
  isNewDesign: PropTypes.bool
};

export default SectionList;
